import AOS from 'aos';

export default function aosInit() {
  AOS.init({
    startEvent: 'DOMContentLoaded',
    initClassName: 'aos-init',
    offset: 150,
    once: true,
    easing: 'ease-in-out',
    delay: 0.5,
    duration: 1000,
    mirror: false,
  });
}
